import { useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { UrlContext } from "../UrlContext";
import { MainNavScreens } from "breadcommon";
import { CashFlowScreen } from "../cash_flow_screen/CashFlowScreen";
import { TransactionsScreen } from "../transactions_screen/TransactionsScreen";
import { buildClasses } from "../utils/buildClasses";
import { MainNavMenu } from "../main_nav/MainNavMenu";
import { SettingsModal } from "../settings_screen/SettingsModal";
import { getSettingsTabParam } from "../settings_screen/settingsDefinitions";
import { PreferencesContext } from "../firebaseio/PreferencesContext";
import { BudgetsScreen } from "../budgets_screen/BudgetsScreen";
import { HomeScreen } from "../home_screen/HomeScreen";
import { BalancesScreen } from "../balances_screen/BalancesScreen";
import { useRyeModal } from "../rye/RyeModal";

export function MainNav(): JSX.Element {
  const urlInfo = useContext(UrlContext);
  const userPrefs = useContext(PreferencesContext);
  const location = useLocation();
  const settingsOpen = getSettingsTabParam(location.search) !== null;
  const { closeModal } = useRyeModal();

  // A dialog opened from Settings (e.g. Add Account) shouldn't outlive it,
  // e.g. when Back closes Settings underneath it. This watches for Settings
  // actually closing, rather than using Settings' unmount, so StrictMode's
  // remount doesn't close a dialog opened together with Settings.
  const wasSettingsOpen = useRef(settingsOpen);
  useEffect(() => {
    if (wasSettingsOpen.current && !settingsOpen) closeModal();
    wasSettingsOpen.current = settingsOpen;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingsOpen]);

  const currentTab = urlInfo.currentTab ?? userPrefs.web.home_screen;

  return (
    <div className={buildClasses("h-screen", "w-screen", "flex", "pt-2", "pr-2", "pb-2")}>
      <MainNavMenu />
      {mainNavToScreen(currentTab)}
      {settingsOpen && <SettingsModal />}
    </div>
  );
}

function mainNavToScreen(mainNav: MainNavScreens): JSX.Element {
  switch (mainNav) {
    case MainNavScreens.HOME:
      return <HomeScreen />;
    case MainNavScreens.TRANSACTIONS:
      return <TransactionsScreen />;
    case MainNavScreens.BALANCES:
      return <BalancesScreen />;
    case MainNavScreens.CASH_FLOW:
      return <CashFlowScreen />;
    case MainNavScreens.BUDGETS:
      return <BudgetsScreen />;
  }
}
